export default __webpack_public_path__ + "static/testimonial-kristiana-2bb18cdfee68a7d88b626c9797e74839.jpg";